module.exports = __webpack_public_path__ + "entry-150bfe9b/illustration-native-app-section-ea64e7bf9c5bc9c95d4e160e919462ee.jpg";